module.exports = __webpack_public_path__ + "img/sdk7.46831e67.png";